export const SIDEBAR_WIDTH = 250;
export const CELL_HEIGHT = 110;
export const MAX_VISIBLE = 3;
export const VUE_OPTIONS = [1, 7, 15, 30];

export const OFFER_COLOR_PALETTE = [
  '#4318FF',
  '#01B574',
  '#FFB547',
  '#EE5D50',
  '#00B5DD',
  '#7551FF',
  '#FF5B87',
  '#22C55E',
  '#F97316',
  '#3B82F6',
  '#A855F7',
  '#E11D48',
  '#14B8A6',
  '#F59E0B',
  '#6366F1',
  '#EC4899',
];

export const STATUS_CONFIG = {
  approved: { label: 'Confirmé', color: '#10B981', bg: '#ECFDF5' },
  pending: { label: 'En attente', color: '#F59E0B', bg: '#FFFBEB' },
  cancelled: { label: 'Annulé', color: '#EF4444', bg: '#FEF2F2' },
  completed: { label: 'Terminé', color: '#6366F1', bg: '#EEF2FF' },
  default: { label: 'Inconnu', color: '#94A3B8', bg: '#F8FAFC' },
};

export const STATUS_OPTIONS = [
  { value: 'approved', label: 'Confirmé' },
  { value: 'pending', label: 'En attente' },
  { value: 'cancelled', label: 'Annulé' },
  { value: 'completed', label: 'Terminé' },
];
